import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';

/** Catalogue des titres professionnels dispensés (écran `catalog`). */
export interface ModuleCatalogue {
  libelle: string;
  heures: number;
}

export interface FormationCatalogue {
  id: string;
  code: string;
  titre: string;
  niveau: string;
  heures: number;
  heuresEcrits: number;
  heuresEcf: number;
  codeDiplome: string;
  rncp: string;
  modules: ModuleCatalogue[];
  dossiersEnCours: number;
  apprenantsEnFormation: number;
  sessionsOuvertes: number;
}

export interface ReponseCatalogue {
  formations: FormationCatalogue[];
  niveaux: string[];
  sites: string[];
  compteurs: {
    formations: number;
    heures: number;
    dossiersEnCours: number;
    sessionsOuvertes: number;
  };
}

export function useCatalogue(site: string, actif = true) {
  return useQuery({
    queryKey: ['catalogue', site],
    queryFn: () =>
      appelApi<ReponseCatalogue>(`/catalogue?${new URLSearchParams({ site }).toString()}`),
    enabled: actif,
  });
}
